import './style.css'

import "@babylonjs/viewer";
import { Scene, WebXRBackgroundRemover } from "@babylonjs/core";

const babylonCanvas = document.getElementById("babylonCanvas");
babylonCanvas.addEventListener("viewerready", () => {
  console.log("viewer ready!");
  babylonCanvas.viewerDetails?.scene.createDefaultXRExperienceAsync({
    disableDefaultUI: true,
    optionalFeatures: true,
  }).then((defaultXRExperience) => {
    if (defaultXRExperience.baseExperience) {
      defaultXRExperience.baseExperience.featuresManager.enableFeature(
          WebXRBackgroundRemover,
          "latest",
          {
              environmentHelperRemovalFlags: {
                  skyBox: true,
                  ground: true,
              }
          }
      );
    }
    document.getElementById("enterXR")?.addEventListener("click", () => {
        if (defaultXRExperience.baseExperience) {
            defaultXRExperience.baseExperience.enterXRAsync("immersive-ar",  "unbounded");
        } else {
            alert("XR not support!");
        }
    });
  });
});